import React from "react";
import { HelpCircle } from "lucide-react";

/**
 * Renders the guest's answers to treatment questions on a booking.
 * Expected shape: booking.answers = [{ question_id, question_text, answer }]
 * Renders nothing when there are no answers.
 */
export default function BookingAnswers({ answers, compact = false }) {
  const list = Array.isArray(answers) ? answers.filter((a) => a && (a.answer ?? "") !== "") : [];
  if (!list.length) return null;
  return (
    <div className={compact ? "mt-3" : "mt-4"} data-testid="booking-answers">
      <div className="overline text-accent mb-2 flex items-center gap-1">
        <HelpCircle className="h-3 w-3" /> Guest answers
      </div>
      <ul className={`space-y-2 ${compact ? "text-xs" : "text-sm"}`}>
        {list.map((a, i) => (
          <li
            key={a.question_id || i}
            className="bg-muted/50 border-l-2 border-accent/60 pl-3 py-1.5"
            data-testid={`answer-${a.question_id || i}`}
          >
            <div className="text-muted-foreground">{a.question_text || "Question"}</div>
            <div className="font-medium text-primary whitespace-pre-wrap">{String(a.answer)}</div>
          </li>
        ))}
      </ul>
    </div>
  );
}
